import {efaAddressBook} from './address-book-en.i18n..ts';


export const en = {
  efaAddressBook
};
